import moment from "moment";
import { IndustryCompany } from "src/app/ui/models/domains/pbm/industry/industry-company.model";
import { IndustryDiscount, IndustryDiscountKey } from "src/app/ui/models/domains/pbm/industry/industry-discount.model";
import {
  IndustryProductDiscountKey,
  IndustryProductDiscounts,
  IndustryProductEan,
} from "src/app/ui/models/domains/pbm/industry/industry-product-discounts.model";

export function parseIndustryDiscounts(payload: any): IndustryDiscount[] {
  if(!payload){
    return [];
  }
  return payload.map((item) => {
    return new IndustryDiscount(
      parseIndustryDiscountKey(item.IndustryDiscountKey),
      parseIndustryCompany(item.Company),
      payload.Data,
      moment(item.Created,'YYYYMMDDTHHmmss').format("DD/MM/YYYY"),
      item.ProductCount,
    );
  });
}

export function parseIndustryDiscount(payload: any): IndustryDiscount {
  if(!payload){
    return null;
  }
  return new IndustryDiscount(
    parseIndustryDiscountKey(payload.IndustryDiscountKey),
    parseIndustryCompany(payload.Company),
    parseIndustryProductDiscounts(payload.Data),
    moment(payload.Created,'YYYYMMDDTHHmmss').format("DD/MM/YYYY"),
    payload.ProductCount,
  );
}

export function parseIndustryCompany(payload: any): IndustryCompany {
  if(!payload){
    return null;
  }
  return new IndustryCompany(payload.FiscalNumber, payload.CorporateName, payload.TradingName);
}

export function parseIndustryProductDiscount(payload: any): IndustryProductDiscounts {
  if(!payload){
    return null;
  }
  return new IndustryProductDiscounts(
    parseIndustryProductDiscountKey(payload.IndustryProductDiscountKey),
    parseIndustryProductEan(payload.Ean),
    payload.UserDiscount,
    payload.DirectDiscount,
    payload.IndirectDiscount,
  );
}

export function parseIndustryProductDiscounts(payload: any): Array<IndustryProductDiscounts> {
  if(!payload){
    return [];
  }
  return payload.map((item) => {
    return new IndustryProductDiscounts(
      parseIndustryProductDiscountKey(item.IndustryProductDiscountKey),
      parseIndustryProductEan(item.Ean),
      item.UserDiscount,
      item.DirectDiscount,
      item.IndirectDiscount,
    );
  });
}

export function parseIndustryDiscountKey(payload: any): IndustryDiscountKey {
  if(!payload){
    return null;
  }
  return new IndustryDiscountKey(payload.Value);
}

export function parseIndustryProductDiscountKey(payload: any): IndustryProductDiscountKey { 
  if(!payload){
    return null;
  }
  return new IndustryProductDiscountKey(payload.Value);
}

export function parseIndustryProductEan(payload: any): IndustryProductEan { 
  if(!payload){
    return null;
  }
  return new IndustryProductEan(payload.Value);
}
